import { render, staticRenderFns } from "./alertPopup.vue?vue&type=template&id=ba6c38e8&scoped=true"
import script from "./alertPopup.vue?vue&type=script&lang=js"
export * from "./alertPopup.vue?vue&type=script&lang=js"
import style0 from "./alertPopup.vue?vue&type=style&index=0&id=ba6c38e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6c38e8",
  null
  
)

export default component.exports